import { TweenMax, TimelineMax } from "gsap";
import Cookies from 'js-cookie';


/* tl.set('.SplashLoaderBar', {
     left: 50,
    scale: 0.9, 
    transformOrigin: '50% 50%',
    ease: Power2.easeOut,
}) */
/* tl.set(bg, {
    scale: 1.02,
    transformOrigin: '50% 50%',
    ease: Back.easeInOut.config(0.3),
}) */
/*
tl.to('.SplashLoaderBar' , 0.7, { width: '80%' })
     .to(el, 0.8, { left: 0 }, "-=0.5")
  .to(bg, 1.5, { scale: 1 }, el); */
        

jQuery(document).ready(function ($) {

  $('.playVideo').on('click', function (e) {
    let videoFrame = $('#video-iframe').html();
    $('#vimeo-popup').addClass('show');
    $('#vimeo-popup .video-hold').html(videoFrame);
    if ($('body').hasClass('openNav')) {
      $('.toggle-menu-2').click();
    }
  });

  $('#toggle-video',).on('click', function (e) {
    let videoFrame = $('#video-iframe').html();
    $('#vimeo-popup').addClass('show');
    $('#vimeo-popup .video-hold').html(videoFrame);
  });

  $('#close-vimeo').on('click', function (e) {
    if ($('#vimeo-popup').hasClass('show')) { 
      $('#vimeo-popup').removeClass('show');
      $('#vimeo-popup .video-hold').html('');
    }
  });

  $(document).keydown(function(e) {
    if (e.keyCode == 27) {
      if ($('#vimeo-popup').hasClass('show')) {
        $('#vimeo-popup').removeClass('show');
        $('#vimeo-popup .video-hold').html('');
      }
    }
  });


  if ($('body').hasClass('home')) {
    const tl = new TimelineMax({});
    //DOC: https://greensock.com/timelinemax
    // https://greensock.com/sequence-video
    let $logo = $('#masthead .site-logo');
    let $navigation = $('#masthead .top-navi');
    let $searchBarBottom = $('#HomeSearchEmployee');
    let $carousel = $('.section-big-slider .owl-carousel');
    let $unfocus = $('#video-unfocus');
    tl.set($logo, {
      top: -200,
      left: -50,
      scale: 0.8, 
      opacity:0,
      transformOrigin: '50% 50%',
      ease: Back.easeInOut.config(0.3)
    })
     tl.set($navigation, {
      top: -500,
      right: -50,
      scale: 0.8, 
      opacity:0,
      transformOrigin: '50% 50%',
      ease: Back.easeInOut.config(0.3)
    })
    tl.set($searchBarBottom, {
      bottom: -500,
      scale: 0.8, 
      opacity:0,
      transformOrigin: '50% 50%',
      ease: Back.easeInOut.config(0.3)
    })/*
    tl.set($carousel, {
      bottom: -500,
      scale: 0.8, 
      opacity:0,
      transformOrigin: '50% 50%',
      ease: Back.easeInOut.config(0.3)
    })*/
    tl.set($unfocus, {
      right: -200,
      opacity: 0, 
      transformOrigin: '50% 50%',
      ease: Back.easeInOut.config(0.3)
    })
  
    let bahr_splash = Cookies.get("bahr_splash");
    let timeout = 2500, loadedTimeout = 1500;
    if (bahr_splash && bahr_splash === 'true') {
      timeout = 30;
      loadedTimeout = 30;
      loadHomePage(timeout, loadedTimeout);
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          loadHomePage(timeout, loadedTimeout);
        }
      };
    }
    
    function loadHomePage(timeout, loadedTimeout) {
      setTimeout(function() {
        $(window).trigger('scroll');
        setTimeout(function() {
          $('body').addClass('loaded');
        }, loadedTimeout);
        $('#splash-screen').addClass('ready'); // ready
        tl.to('#splash-screen', 0.5, { opacity: 0, display: 'none', delay: 0 } )
          .to($logo, 0.7, { top: 0, left: 0, scale: 1, opacity:1 }, "feature") //feature aby wykonało się odrazu po poprzedniej
          .to($navigation, 0.7, { top: 4, right: 0, scale: 1, opacity:1 }, "feature")
          /*.to($carousel, 0.7, { bottom: 120, scale: 1, opacity:1 }, "feature+=0.1")*/
          .to($searchBarBottom, 0.7, { bottom: 0, scale: 1, opacity:1 }, "feature+=0.3")
      },timeout);
    }

   
  }



  var iframe_container = $('#vimeo-player');
  if (iframe_container.length) {
    /*
    var options = {
      id: vimeo_id,
      loop: true,
      portrait: 0,
      byline: 0,
      title: 0,
      badge: 0,
      loop: 1,
      autopause: 0,
      autoplay: 0,
      api: 1,
      rel: 0,
      background: 1, // https://github.com/vimeo/player.js/issues/170
      player_id: 'cover-video',
    };
    */
    var timeout;
    var iframe = iframe_container.find('iframe');
    var player = new Vimeo.Player(iframe[0]);
    var paused = false;
    var body = $('body');
    var volUp, volDown;


  
    function resize_video() {
      var min_h = $(window).height();
      var min_w = $(window).width();
      iframe_container.css({ 
        'height': min_h+'px',
      });
      if((min_w/16)*9 < min_h) {
        var w = (min_h/9)*16;
        iframe.css({
          'width': w+'px',
        })
      } else {
        var h = (min_w/16)*9;
        iframe.css({
          'width': min_w+'px',
          'height': h+'px',
        })
      }
    }

    $(window).resize(function() {
      clearTimeout(timeout);
      timeout = setTimeout(resize_video, 100);
    });

    resize_video();
    //console.log(player);

    function video_focus() {
      body.addClass('video-focus');
      player.setVolume(1);
      tl.to($navigation, 0.7, { top: -500, opacity:0 })
        .to($carousel, 0.7, { bottom: -300, opacity:0.5 }, '-=0.7')
        .to($searchBarBottom, 0.7, { bottom: -300, opacity:0.5 }, '-=0.7')
        .to($unfocus, 0.7, { right: 15, opacity: 1 }, '-=0.5')
      setTimeout(function() {
        $carousel.hide();
        $searchBarBottom.hide();
      },700)
    }

    function video_unfocus() {
      body.removeClass('video-focus');
      player.setVolume(0);
      $carousel.show();
      $searchBarBottom.show();
      tl.to($navigation, 0.7, { top: 0, opacity:1 })
        .to($carousel, 0.7, { bottom: 120, opacity:1 }, '-=0.7')
        .to($searchBarBottom, 0.7, { bottom: 0, opacity:1 }, '-=0.7')
        .to($unfocus, 0.7, { right: -200, opacity: 0 }, '-=0.9')
    }

    /*function volume_up() {
      clearInterval(volDown);
      volUp = setInterval(function() {
        player.getVolume().then(vol => {
          console.log(vol);
          var volume = parseInt(vol);
          var newVolume = volume;
          if(volume > .8) {
            clearInterval(volUp);
          }
          newVolume = newVolume + 0.1;
          player.setVolume(newVolume);
        })
      }, 1000/10);
    }*/

    $('#toggle-video').on('click', function(e) { 
      // console.log('icon',e.target.tagName);
      video_focus()
    });
    
    $('#video-unfocus').on('click', function() { 
      video_unfocus()
    });

    $('.cv-locker, #masthead').on('click', function(e) {
      if(e.target.tagName !== 'DIV') return
      if(!body.hasClass('video-focus')) {
        video_focus()
      } else {
        video_unfocus()
      }
    });

    

    var header = $('#masthead');
    $(window).on('scroll', function() {
      if($(this).scrollTop() > $(window).height()) {
        if(!header.hasClass('white')) {
          header.addClass('white')
        }
      } else {
        if(header.hasClass('white')) {
          header.removeClass('white')
        }
      }
    })
    


  }

});


// WEBPACK FOOTER //
// ./src/js/imports/video.js